module.exports = __webpack_public_path__ + "static/kuchnia-photo02_thumb-bdf2d801b3b958a1e259ec5d9a983f17.jpg";